/**
 * Created by zhengyf on 2017.11.23.
 */

;(function () {

    DiagnosisCenterCtrl.$inject = ['$scope', '$timeout', '$filter', 'request', 'dataAdminDiagnosisData', 'realtimeConfig', 'previousConfig', 'summaryConfig', 'analysisConfig'];
    angular
        .module('DSSXAPP')
        .filter('percentage', ['$filter', function ($filter) {
            return function (input, decimals) {
                return $filter('number')(input * 100, decimals) + '%';
            };
        }])
        .component('diagnosisCenter', {
            template:'<div class="data-admin-component data-admin-diagnosis-center"><div><h3>首页</h3><span>店铺切换 <i class="iconfont icon-moreunfold"></i></span><div>过滤中国流量<div></div></div></div><div class="data-admin-diagnosis-realtime"><div class="data-admin-diagnosis-realtime-block"><div class="data-admin-diagnosis-realtime-block-title">数据看板 <span>更新时间：{{vm.d.realTimeShopStats.statDate | date: \'yyyy-MM-dd\'}}&nbsp;PST</span></div><div class="data-admin-diagnosis-realtime-block-content"><div class="data-admin-diagnosis-realtime-block-content-select"><div ng-class="{\'active\': vm.c.statView === \'realtime\'}" ng-click="vm.f.changeStatView(\'realtime\')">实时</div><div ng-class="{\'active\': vm.c.statView === \'previous\'}" ng-click="vm.f.changeStatView(\'previous\')">昨日</div></div><div class="data-admin-diagnosis-realtime-block-content-trend" ng-show="vm.c.statView === \'realtime\'"><div>店铺访问人数</div><div>{{vm.d.shopSummary.realtime[vm.c.summaryList[0].type].value}}</div><div><div>较昨日：<span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.realTimeShopStats.shopUv.cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.realTimeShopStats.shopUv.cycleCrc < 0}">{{vm.d.realTimeShopStats.shopUv.cycleCrc | percentage: 1}}</span></div><div>无线占比：<span>{{vm.d.realTimeShopStats.shopUv.wsPercent | percentage: 1}}</span></div></div><div id="data-admin-diagnosis-realtime-trend"></div></div><div class="data-admin-diagnosis-realtime-block-content-stats" ng-show="vm.c.statView === \'realtime\'"><div><div></div><div><div>店铺访问次数</div><div>{{vm.d.realTimeShopStats.shopPv.value}}</div><div><div>较昨日： <span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.realTimeShopStats.shopPv.cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.realTimeShopStats.shopPv.cycleCrc < 0}"><span ng-show="vm.d.realTimeShopStats.shopPv.cycleCrc > 0">+</span> {{vm.d.realTimeShopStats.shopPv.cycleCrc | percentage: 1}}</span></div><div>无线占比： <span>{{vm.d.realTimeShopStats.shopUv.wsPercent | percentage: 1}}</span></div></div></div></div><div><div></div><div><div>询盘个数</div><div>{{vm.d.realTimeShopStats.fbPv.value}}</div><div><div>较昨日： <span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.realTimeShopStats.fbPv.cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.realTimeShopStats.fbPv.cycleCrc < 0}"><span ng-show="vm.d.realTimeShopStats.fbPv.cycleCrc > 0">+</span> {{vm.d.realTimeShopStats.fbPv.cycleCrc | percentage: 1}}</span></div><div>无线占比： <span>{{vm.d.realTimeShopStats.fbPv.wsPercent | percentage: 1}}</span></div></div></div></div></div><div class="data-admin-diagnosis-realtime-block-content-trend" ng-show="vm.c.statView === \'previous\'"><div>店铺访问人数</div><div>{{vm.d.offlineShopStats.shopUv.value}}</div><div><div>较前日：<span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.offlineShopStats.shopUv.cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.offlineShopStats.shopUv.cycleCrc < 0}">{{vm.d.offlineShopStats.shopUv.cycleCrc | percentage: 1}}</span></div><div>无线占比：<span>{{vm.d.offlineShopStats.shopUv.wsPercent | percentage: 1}}</span></div></div><div id="data-admin-diagnosis-previous-trend"></div></div><div class="data-admin-diagnosis-realtime-block-content-stats" ng-show="vm.c.statView === \'previous\'"><div><div></div><div><div>店铺访问次数</div><div>{{vm.d.offlineShopStats.shopPv.value}}</div><div><div>较前日： <span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.offlineShopStats.shopPv.cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.offlineShopStats.shopPv.cycleCrc < 0}"><span ng-show="vm.d.offlineShopStats.shopPv.cycleCrc > 0">+</span> {{vm.d.offlineShopStats.shopPv.cycleCrc | percentage: 1}}</span></div><div>无线占比： <span>{{vm.d.offlineShopStats.shopUv.wsPercent | percentage: 1}}</span></div></div></div></div><div><div></div><div><div>询盘个数</div><div>{{vm.d.offlineShopStats.fbPv.value}}</div><div><div>较前日： <span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.offlineShopStats.fbPv.cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.offlineShopStats.fbPv.cycleCrc < 0}"><span ng-show="vm.d.offlineShopStats.fbPv.cycleCrc > 0">+</span> {{vm.d.offlineShopStats.fbPv.cycleCrc | percentage: 1}}</span></div><div>无线占比： <span>{{vm.d.offlineShopStats.fbPv.wsPercent | percentage: 1}}</span></div></div></div></div></div><div class="data-admin-diagnosis-realtime-block-content-stats" ng-show="vm.c.statView === \'previous\'"><div><div></div><div><div>店铺转化率</div><div>{{vm.d.offlineShopStats.conversionRate.value | percentage: 2}}</div><div><div>较前日： <span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.offlineShopStats.conversionRate.percentPoint > 0, \'data-admin-diagnosis-color-down\': vm.d.offlineShopStats.conversionRate.percentPoint < 0}"><span ng-show="vm.d.offlineShopStats.conversionRate.percentPoint > 0">+</span> {{vm.d.offlineShopStats.conversionRate.percentPoint * 100 | number: 2}}pp</span></div><div style="visibility: hidden">无线占比： <span>{{vm.d.offlineShopStats.conversionRate.percentPoint * 100 | number: 2}}pp</span></div></div></div></div><div><div></div><div><div>TM咨询人数</div><div>{{vm.d.offlineShopStats.tmCount.value}}</div><div><div>较前日： <span ng-class="{\'data-admin-diagnosis-color-up\': vm.d.offlineShopStats.tmCount.cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.offlineShopStats.tmCount.cycleCrc < 0}"><span ng-show="vm.d.offlineShopStats.tmCount.cycleCrc > 0">+</span> {{vm.d.offlineShopStats.tmCount.cycleCrc | percentage: 1}}</span></div><div>无线占比： <span>{{vm.d.offlineShopStats.tmCount.wsPercent | percentage: 1}}</span></div></div></div></div></div></div></div><div class="data-admin-diagnosis-realtime-business"><div class="data-admin-diagnosis-realtime-block-title">商家星等级</div><div class="data-admin-diagnosis-realtime-business-star"><div>评定星等级 <span id="data-admin-diagnosis-business-appraise-star"><i class="iconfont icon-favoritesfilling"></i> <i class="iconfont icon-favoritesfilling"></i> <i class="iconfont icon-favoritesfilling"></i></span></div><div>预测星等级 <span id="data-admin-diagnosis-business-forecast-star"><i class="iconfont icon-favoritesfilling"></i> <i class="iconfont icon-favoritesfilling"></i> <i class="iconfont icon-favoritesfilling"></i></span></div></div><div class="data-admin-diagnosis-realtime-block-title">数据学堂</div><div class="data-admin-diagnosis-realtime-business-announce"><i class="iconfont icon-remind"></i> <a>行业版“关键词指数”，解密买家采购行为</a></div><div class="data-admin-diagnosis-realtime-business-shuffling"><div class="data-admin-diagnosis-realtime-business-shuffling-container"><div><a href="https://activity.alibaba.com/supplier/a1b82804.html" target="_blank"></a></div><div><a href="https://waimaoquan.alibaba.com/bbs/read-htm-tid-4105371-1-fid-11.html" target="_blank"></a></div></div></div></div></div><div class="data-admin-diagnosis-anchor"><div><a>经营数据</a> <a>热品热词</a></div><div><span ng-click="vm.f.toggleShowDateWeekSelector(true)"><i class="iconfont icon-calendar"></i> {{vm.c.curSelectedResult}}&nbsp;PST <i class="iconfont icon-moreunfold"></i></span> <button ng-class="{\'disabled\': vm.c.curSelected >= vm.c.selectedRange[vm.c.curSelectedType].max}" ng-disabled="vm.c.curSelected >= vm.c.selectedRange[vm.c.curSelectedType].max || vm.c.pending" ng-click="vm.f.stepSelect(false)"><i class="iconfont icon-back"></i></button> <button ng-class="{\'disabled\': vm.c.curSelected <= vm.c.selectedRange[vm.c.curSelectedType].min}" ng-disabled="vm.c.curSelected <= vm.c.selectedRange[vm.c.curSelectedType].min || vm.c.pending" ng-click="vm.f.stepSelect(true)"><i class="iconfont icon-more"></i></button><div class="data-admin-diagnosis-day-week-selector" ng-show="vm.c.showDateWeekSelector"><div class="data-admin-diagnosis-day-week-selector-panel"><ul><li ng-repeat="stats in vm.c.statsMenus track by $index" ng-attr-id="{{stats.btnId}}" ng-click="vm.f.selectDateWeekType(stats, $index, $event)" ng-class="{\'current\': vm.c.curStatsIndex === $index}">{{stats.title}} <label><input ng-attr-id="{{stats.dateId}}"></label></li></ul><div><div ng-attr-id="{{vm.c.statsMenus[0].dateId}}" ng-show="vm.c.curStatsIndex === 0"></div><date-week max="vm.c.curDate" week-range="vm.c.weekRange" on-change="vm.f.weekChange($event)" ng-click="$event.stopPropagation()" ng-show="vm.c.curStatsIndex === 1"></date-week><div ng-attr-id="{{vm.c.statsMenus[2].dateId}}" ng-show="vm.c.curStatsIndex === 2"></div></div></div></div><div class="data-admin-diagnosis-mask" ng-show="vm.c.showDateWeekSelector" ng-click="vm.f.toggleShowDateWeekSelector(false)"></div></div></div><div class="data-admin-diagnosis-summary"><div class="data-admin-diagnosis-summary-head"><div class="data-admin-diagnosis-summary-title">经营数据</div><div class="data-admin-diagnosis-summary-selector"><label><input type="checkbox" disabled> 展示类目下的产品效果</label> <span>标杆行业 <label><select disabled><option>{{vm.d.industries[0].parentIndustryDesc}}&nbsp;>&nbsp;{{vm.d.industries[0].industryDesc}}</option></select></label></span> <label><select disabled><option>全部终端</option><option>PC</option><option>无线</option></select></label> <button ng-class="{\'active\': vm.c.summaryView === \'charts\'}" ng-click="vm.f.changeSummaryView(\'charts\')"><i class="fa fa-line-chart"></i></button> <button ng-class="{\'active\': vm.c.summaryView === \'table\'}" ng-click="vm.f.changeSummaryView(\'table\')"><i class="fa fa-columns"></i></button></div></div><div class="data-admin-diagnosis-summary-detail"><div class="data-admin-diagnosis-summary-detail-view" ng-show="vm.c.summaryView === \'charts\'"><div class="data-admin-diagnosis-summary-detail-view-main"><div class="data-admin-diagnosis-summary-detail-view-main-content" ng-class="{\'next\': vm.c.summaryShowNext}"><ul ng-repeat="summary in vm.c.summaryList track by $index" ng-click="vm.f.changeSummaryIndex($index)"><li ng-class="{\'active\': $index === vm.c.summaryListIndex}"><div>{{summary.name}}</div><div>{{vm.d.shopSummary.realtime[summary.type].value}}</div><div>较上{{vm.c.curSelectedType === \'month\' ? \'月\' : \'周\'}}： <span ng-show="$index < 7" ng-class="{\'data-admin-diagnosis-color-up\': vm.d.shopSummary.realtime[summary.type].cycleCrc > 0, \'data-admin-diagnosis-color-down\': vm.d.shopSummary.realtime[summary.type].cycleCrc < 0}"><span ng-show="vm.d.shopSummary.realtime[summary.type].cycleCrc > 0">+</span> {{vm.d.shopSummary.realtime[summary.type].cycleCrc | percentage: 1}}</span> <span ng-hide="$index < 7">--</span></div></li></ul></div></div><div class="data-admin-diagnosis-summary-detail-view-select previous" ng-show="vm.c.summaryShowNext" ng-click="vm.c.summaryShowNext = false;"><i class="iconfont icon-back"></i></div><div class="data-admin-diagnosis-summary-detail-view-select next" ng-hide="vm.c.summaryShowNext" ng-click="vm.c.summaryShowNext = true;"><i class="iconfont icon-more"></i></div></div><div class="data-admin-diagnosis-summary-detail-chart" ng-repeat="summary in vm.c.summaryList track by $index" ng-show="vm.c.summaryView === \'charts\' && vm.c.summaryListIndex === $index">趋势分析<div id="{{vm.c.summaryLineChartPrefix + summary.type}}"></div><div></div>国家及地区分析<div class="data-admin-diagnosis-summary-detail-analysis"><div><div id="{{vm.c.summaryPieCHartPrefix + summary.type}}"></div></div><div><table><thead><tr><th>国家及地区TOP20</th><th>{{summary.name}}</th><th>{{summary.name}}占比</th></tr></thead><tbody><tr ng-repeat="detail in vm.d.shopRegionAnalysis[summary.type][summary.analysisIndex].detail track by $index" ng-show="$index < 7"><td>{{detail.key}}</td><td>{{detail.value}}</td><td>{{detail.percentage}}</td></tr></tbody></table></div></div></div><div class="data-admin-diagnosis-summary-detail-table" ng-show="vm.c.summaryView === \'table\'"><table><thead><tr><th rowspan="2">类别</th><th rowspan="2">指标名称</th><th colspan="4">{{vm.d.shopSummary.realtime.date}}</th><th colspan="4">{{vm.d.shopSummary.previous.date}}</th></tr><tr><th>当前值</th><th>较上周</th><th>行业平均</th><th>同行优秀</th><th>当前值</th><th>较上周</th><th>行业平均</th><th>同行优秀</th></tr></thead><tbody><tr ng-repeat="summary in vm.c.summaryList track by $index"><td ng-if="$index === 0" rowspan="4">流量</td><td ng-if="$index === 4" rowspan="3">商机</td><td ng-if="$index === 7" rowspan="2">交易</td><td>{{summary.name}}</td><td>{{vm.d.shopSummary.realtime[summary.type].value}}</td><td><span ng-show="$index < 7"><span ng-show="vm.d.shopSummary.realtime[summary.type].cycleCrc > 0">+</span> {{vm.d.shopSummary.realtime[summary.type].cycleCrc | percentage: 1}}</span> <span ng-hide="$index < 7">--</span></td><td>{{vm.d.shopSummary.realtime[summary.type].rivalAvg}}</td><td>{{vm.d.shopSummary.realtime[summary.type].rivalGood}}</td><td>{{vm.d.shopSummary.previous[summary.type].value}}</td><td><span ng-show="$index < 7"><span ng-show="vm.d.shopSummary.previous[summary.type].cycleCrc > 0">+</span> {{vm.d.shopSummary.previous[summary.type].cycleCrc | percentage: 1}}</span> <span ng-hide="$index < 7">--</span></td><td>{{vm.d.shopSummary.previous[summary.type].rivalAvg}}</td><td>{{vm.d.shopSummary.previous[summary.type].rivalGood}}</td></tr></tbody></table></div></div></div><div class="data-admin-diagnosis-ad"></div><div class="data-admin-diagnosis-product-keyword"><div class="data-admin-diagnosis-product"><div class="data-admin-diagnosis-product-keyword-title">店铺热品 <a>更多></a></div><table><thead><tr><th>商品</th><th>访客数</th><th>询盘数</th></tr></thead><tbody><tr ng-repeat="product in vm.d.products track by $index"><td><div><img ng-src="{{product.imageURL}}"> <a>{{product.subject}}</a></div></td><td>{{product.sumProdVisitorCnt}}</td><td>{{product.sumProdFbNum}}</td></tr></tbody></table></div><div class="data-admin-diagnosis-keyword"><div class="data-admin-diagnosis-product-keyword-title">引流热词 <a>更多></a></div><table><thead><tr><th>关键词</th><th>曝光量</th><th>点击率</th></tr></thead><tbody><tr ng-repeat="keyword in vm.d.keywords track by $index"><td>{{keyword.query}}</td><td>{{keyword.impression}}</td><td>{{keyword.clickRate}}</td></tr></tbody></table></div></div></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: DiagnosisCenterCtrl
        });

    function DiagnosisCenterCtrl($scope, $timeout, $filter, request, dataAdminDiagnosisData, realtimeConfig, previousConfig, summaryConfig, analysisConfig) {

        var vm = this,
            DAY_TIMES_TAMP = 24 * 3.6e3 * 1e3,
            weekRangeAttrs = [],
            weekRangeContents = [],
            triggerCount = 0,
            validMonthRange = {
                min: '',
                max: new Date(DSSX.util.getServerCurrentTime().getFullYear() + '-' + (DSSX.util.getServerCurrentTime().getMonth() + 1) + '-01' + ' 00:00:00').getTime() - 1000
            },
            store = {
                monthPlugin: {
                    lastChange: {
                        year: NaN,
                        month: NaN
                    }
                }
            };

        vm.c = {
            ts: DAY_TIMES_TAMP,
            selectedRange: {
                day: {
                    min: 1,
                    max: 90
                },
                week: {
                    min: 1,
                    max: 12
                },
                month: {
                    min: 1,
                    max: 3
                }
            },
            curSelected: 1,
            curSelectedType: 'day',
            curSelectedResult: '',
            curDate: new Date(DSSX.util.getServerCurrentTime().getTime() - DAY_TIMES_TAMP * 2),
            weekRange: {},
            curStatsIndex: 0,
            statsMenus: [ // 统计菜单
                {
                    title: '天',
                    btnId: 'day-btn',
                    dateId: 'date-day',
                    type: 'date',
                    min: '2017-8-30',
                    max: '2017-11-29',
                    lang: 'en',
                    oldValue: '2017-11-28'
                },
                {
                    title: '周',
                    btnId: 'week-btn',
                    dateId: 'date-week',
                    type: 'week',
                    min: '2017-8-30',
                    max: '2017-11-29',
                    lang: 'en'
                },
                {
                    title: '月',
                    btnId: 'month-btn',
                    dateId: 'date-month',
                    type: 'month',
                    min: '2017-8-1',
                    max: '2017-10-31',
                    lang: 'cn',
                    oldValue: '2017-10'
                }
            ],
            showDateWeekSelector: false,
            pending: false,
            statView: '',
            summaryView: '',
            summaryShowNext: false,
            summaryLineChartPrefix: 'data-admin-diagnosis-summary-chart-',
            summaryPieCHartPrefix: 'data-admin-diagnosis-analysis-chart-',
            summaryListIndex: 0,
            summaryList: [{
                name: '店铺访问人数',
                type: 'shopUv',
                lineChart: null,
                pieChart: null,
                analysisIndex: 0
            }, {
                name: '店铺访问次数',
                type: 'shopPv',
                lineChart: null,
                pieChart: null,
                analysisIndex: 0
            }, {
                name: '搜索曝光次数',
                type: 'searchImps',
                lineChart: null,
                pieChart: null,
                analysisIndex: 0
            }, {
                name: '搜索点击次数',
                type: 'searchClicks',
                lineChart: null,
                pieChart: null,
                analysisIndex: 0
            }, {
                name: '询盘人数',
                type: 'fbUv',
                lineChart: null,
                pieChart: null,
                analysisIndex: 0
            }, {
                name: '询盘个数',
                type: 'fbPv',
                lineChart: null,
                pieChart: null,
                analysisIndex: 0
            }, {
                name: 'TM咨询人数',
                type: 'tmUv',
                lineChart: null,
                pieChart: null,
                analysisIndex: 0
            }, {
                name: '信保交易订单个数',
                type: 'orderCount',
                lineChart: null
            }, {
                name: '信保订单交易金额（美元）',
                type: 'orderAmount',
                lineChart: null
            }]
        };

        vm.d = {};

        vm.f = {
            changeStatView: changeStatView,
            changeSummaryView: changeSummaryView,
            changeSummaryIndex: changeSummaryIndex,
            getBusinessData: getBusinessData,
            weekChange: weekChange,
            selectDateWeekType: selectDateWeekType,
            toggleShowDateWeekSelector: toggleShowDateWeekSelector,
            stepSelect: stepSelect,
        };

        $scope.$watch('vm.c.weekRange', function (newVal) {
            vm.c.weekRange = newVal;
            weekRangeAttrs = [];
            for (var attr in vm.c.weekRange) {
                if (!vm.c.weekRange.hasOwnProperty(attr)) {
                    continue;
                }
                weekRangeAttrs.unshift(attr);
                weekRangeContents = weekRangeContents.concat([].concat(vm.c.weekRange[attr]).reverse());
                validMonthRange.min = new Date(attr + '-01 00:00:00').getTime();
            }
        });

        init();

        function init() {
            console.log('[DiagnosisCenterCtrl init: ]');

            $timeout(function () {
                initTips();
                initCharts();
                initVM();
                getBusinessData(1, 'day', $filter('date')(vm.c.curDate, 'yyyy-MM-dd'));
            });
        }

        function initTips() {
            showTip("#data-admin-diagnosis-business-appraise-star", "#data-admin-diagnosis-business-appraise-star", "评定星等级根据上个月最后一个自然日的四个能力项分数综合评定，每月5日更新。四个能力项需同时满足分数标准才能晋级对应的星等级。一星需四个能力项均达到60分，二星需要均达到70分，三星需要均达到80分。");
            showTip("#data-admin-diagnosis-business-forecast-star", "#data-admin-diagnosis-business-forecast-star", "当前等级：二星，依据四个能力项预测在下个月将达到的星等级，每日更新");
        }

        function initCharts() {
            var realtimeCharts = echartsV3.init($('#data-admin-diagnosis-realtime-trend')[0]);
            var previousCharts = echartsV3.init($('#data-admin-diagnosis-previous-trend')[0]);

            realtimeCharts.setOption(getRealtimeConfig(dataAdminDiagnosisData.realTimeShopStats.realtimeTrend, dataAdminDiagnosisData.realTimeShopStats.previousTrend));
            previousCharts.setOption(getPreviousConfig(dataAdminDiagnosisData.offlineShopStats.uvTrend));

            vm.c.summaryList.forEach(function (value, index) {
                vm.c.summaryList[index].lineChart = echartsV3.init($('#' + vm.c.summaryLineChartPrefix + value.type)[0]);
                // vm.c.summaryList[index].lineChart.setOption(getSummaryConfig(dataAdminDiagnosisData.shopTrends[value.type]));
                'pieChart' in value && (function () {
                    vm.c.summaryList[index].pieChart = echartsV3.init($('#' + vm.c.summaryPieCHartPrefix + value.type)[0]);
                    vm.c.summaryList[index].pieChart.setOption(getAnalysisConfig(dataAdminDiagnosisData.shopRegionAnalysis[value.type], value.name + '占比'));
                    vm.c.summaryList[index].pieChart.on('click', function (param) {
                        handlePieChartSelected(param);
                    });
                }());
            });
        }

        function initVM() {
            vm.c.statView = 'realtime';
            vm.c.summaryView = 'charts';
            vm.d = dataAdminDiagnosisData;

            var max = vm.c.curDate.getTime();
            var min = max - DAY_TIMES_TAMP * (vm.c.selectedRange.day.max - 1);
            var minDate = $filter('date')(new Date(min), 'yyyy-MM-dd'); // 当前年月日
            var maxDate = $filter('date')(new Date(max), 'yyyy-MM-dd'); // 当前年月日
            for (var i = 0; i < vm.c.statsMenus.length; i++) {
                if (vm.c.statsMenus[i].type !== 'month') {
                    vm.c.statsMenus[i].min = minDate;
                    vm.c.statsMenus[i].max = maxDate;
                    vm.c.statsMenus[i].oldValue = $filter('date')(vm.c.curDate, 'yyyy-MM-dd');
                } else {
                    var minYM = minDate.slice(0, -3);
                    var minD = minYM + '-01';
                    var maxYear = new Date(max).getFullYear();
                    var maxMonth = new Date(max).getMonth();
                    var maxD = maxYear + '-' + maxMonth + '-28';

                    vm.c.statsMenus[i].min = minD;
                    vm.c.statsMenus[i].max = maxD;
                    vm.c.statsMenus[i].oldValue = maxYear + '-' + maxMonth;
                }
            }
        }

        function showTip(target, anchor, msg) {
            var id;
            $(target).hover(function () {
                id = layer.tips('<span style="color: #333333;">' + msg + '</span>', anchor, {
                    tips: [3, '#ffffff'],
                    time: 2000000
                });
            }, function () {
                layer.close(id);
            });
        }

        /**
         * 切花顶部数据视图
         * @param arg_view string
         */
        function changeStatView(arg_view) {
            if (vm.c.statView === arg_view) {
                return;
            }
            vm.c.statView = arg_view;
        }

        /**
         * 切换统计视图
         * @param arg_view string
         */
        function changeSummaryView(arg_view) {
            if (vm.c.summaryView === arg_view) {
                return;
            }

            vm.c.summaryView = arg_view;
        }

        /**
         * 切换统计位置
         * @param arg_index number
         */
        function changeSummaryIndex(arg_index) {
            if (!(arg_index in vm.c.summaryList)) {
                return;
            }

            if (arg_index === vm.c.summaryListIndex) {
                return;
            }

            vm.c.summaryListIndex = arg_index;
        }

        /**
         * 获取实时折线图配置
         * @param arg_realtimeData array 实时数据源
         * @param arg_previousData array 昨日数据源
         * @returns {*}
         */
        function getRealtimeConfig(arg_realtimeData, arg_previousData) {
            var config = angular.copy(realtimeConfig, {});

            var keys = [], realtimeValues = [], previousValues = [];
            Array.isArray(arg_realtimeData) && arg_realtimeData.forEach(function (element) {
                keys.push(element.key);
                realtimeValues.push(element.value);
            });
            Array.isArray(arg_previousData) && arg_previousData.forEach(function (element) {
                previousValues.push(element.value);
            });

            config.xAxis.data = keys;
            config.series[0].data = previousValues;
            config.series[1].data = realtimeValues;
            return config;
        }

        /**
         * 获取昨日折线图配置
         * @param arg_data array 数据源
         * @returns {*}
         */
        function getPreviousConfig(arg_data) {
            var config = angular.copy(previousConfig, {});

            var keys = [], values = [];
            Array.isArray(arg_data) && arg_data.forEach(function (element) {
                keys.push(formatDate(element.key));
                values.push(element.value);
            });

            config.xAxis.data = keys;
            config.series[0].data = values;
            return config;
        }

        /**
         * 获取趋势配置
         * @param arg_data array 数据源
         * @returns {*}
         */
        function getSummaryConfig(arg_data) {
            var config = angular.copy(summaryConfig, {});

            var keys = [], mineValues = [], avgValues = [], goodValues = [];
            Array.isArray(arg_data) && arg_data.forEach(function (element) {
                keys.push(element.key);
                mineValues.push(element.mine);
                avgValues.push(element.average);
                goodValues.push(element.good);
            });

            config.xAxis.data = keys;
            config.series[0].data = mineValues;
            config.series[1].data = avgValues;
            config.series[2].data = goodValues;
            return config;
        }

        /**
         * 获取饼图配置
         * @param arg_data array 数据源
         * @param arg_title string 标题
         * @returns {*}
         */
        function getAnalysisConfig(arg_data, arg_title) {
            var config = angular.copy(analysisConfig, {});

            var keys = [], values = [];
            Array.isArray(arg_data) && arg_data.forEach(function (element) {
                keys.push({
                    name: element.key,
                    icon: 'pin'
                });
                values.push({
                    name: element.key,
                    value: element.value
                });
            });

            config.title.text = arg_title;
            config.legend.data = keys;
            config.series[0].data = values;
            return config;
        }

        /**
         * 格式化时间
         * @param arg_ts number
         * @returns {*}
         */
        function formatDate(arg_ts) {
            return $filter('date')(new Date(arg_ts), 'yyyy-MM-dd');
        }

        function handlePieChartSelected(arg_param) {
            if (!arg_param) {
                return;
            }
            if (!(vm.c.summaryListIndex in vm.c.summaryList)) {
                return;
            }

            if (!(arg_param.dataIndex in vm.d.shopRegionAnalysis[vm.c.summaryList[vm.c.summaryListIndex].type])) {
                return;
            }

            vm.c.summaryList[vm.c.summaryListIndex].analysisIndex = arg_param.dataIndex;
            $timeout(function () {
                $scope.$apply();
            });
        }

        /**
         * @param argSelected number
         * @param argType string
         * @param argDate string
         */
        function getBusinessData(argSelected, argType, argDate) {
            if (vm.c.pending) {
                return;
            }

            if (argType !== 'day' && argType !== 'week' && argType !== 'month') {
                DSSX.dialog.msg('无效的数据类型');
                return;
            }

            if (argSelected < vm.c.selectedRange[argType].min || argSelected > vm.c.selectedRange[argType].max) {
                DSSX.dialog.msg('超出时间范围');
                return;
            }

            vm.c.pending = true;
            request.get('/pub/api/loadBizData', {
                type: 'business',
                statisticsType: argType,
                selected: argSelected
            }).then(function (res) {
                vm.c.curSelected = argSelected;
                vm.c.curSelectedType = argType;
                vm.c.curSelectedResult = argDate;
                handleShopSummary(DSSX.util.safe(res, 'data.shopSummary', []));
                handleShopTrends(DSSX.util.safe(res, 'data.shopTrends', []));
            }, function (err) {
                DSSX.dialog.err(err, {
                    moduleName: '[diagnosis-center.js]',
                    funcName: 'getBusinessData',
                    text: '获取数据失败'
                });
            }).finally(function () {
                vm.c.pending = false;
            });
        }

        /**
         * @param argData array
         */
        function handleShopSummary(argData) {
            if (!Array.isArray(argData) || argData.length !== 2) {
                return;
            }

            vm.d.shopSummary = {
                realtime: {
                    date: getSelectedResult(vm.c.curSelected, vm.c.curSelectedType),
                    shopUv: argData[0].shopUv,
                    shopPv: argData[0].shopPv,
                    searchImps: argData[0].searchImps,
                    searchClicks: argData[0].searchClicks,
                    fbUv: argData[0].fbUv,
                    fbPv: argData[0].fbPv,
                    tmUv: argData[0].tmUv,
                    orderCount: argData[0].orderCount,
                    orderAmount: argData[0].orderAmount
                },
                previous: {
                    date: getSelectedResult(vm.c.curSelected + 1, vm.c.curSelectedType),
                    shopUv: argData[1].shopUv,
                    shopPv: argData[1].shopPv,
                    searchImps: argData[1].searchImps,
                    searchClicks: argData[1].searchClicks,
                    fbUv: argData[1].fbUv,
                    fbPv: argData[1].fbPv,
                    tmUv: argData[1].tmUv,
                    orderCount: argData[1].orderCount,
                    orderAmount: argData[1].orderAmount
                }
            };
        }

        /**
         * @param argData array
         */
        function handleShopTrends(argData) {
            if (!Array.isArray(argData)) {
                return;
            }

            vm.d.shopTrends = {
                shopUv: trimShopTrendsData(argData, 'shopUv', 'shopUvRivalAvg', 'shopUvRivalGood'),
                shopPv: trimShopTrendsData(argData, 'shopPv', 'shopPvRivalAvg', 'shopPvRivalGood'),
                searchImps: trimShopTrendsData(argData, 'searchImps', 'searchImpsRivalAvg', 'searchImpsRivalGood'),
                searchClicks: trimShopTrendsData(argData, 'searchClicks', 'searchClicksRivalAvg', 'searchClicksRivalGood'),
                fbUv: trimShopTrendsData(argData, 'fbUv', 'fbUvRivalAvg', 'fbUvRivalGood'),
                fbPv: trimShopTrendsData(argData, 'fbPv', 'fbPvRivalAvg', 'fbPvRivalGood'),
                tmUv: trimShopTrendsData(argData, 'tmUv', 'tmUvRivalAvg', 'tmUvRivalGood'),
                orderCount: trimShopTrendsData(argData, 'orderCount', 'orderCountRivalAvg', 'orderCountRivalGood'),
                orderAmount: trimShopTrendsData(argData, 'orderAmount', 'orderAmountRivalAvg', 'orderAmountRivalGood')
            };

            $timeout(function () {
                vm.c.summaryList.forEach(function (value, index) {
                    vm.c.summaryList[index].lineChart.setOption(getSummaryConfig(vm.d.shopTrends[value.type]));
                });
            });
        }

        /**
         * @param argData array 源数据
         * @param argMine string 我的效果字段
         * @param argAverage string 行业平均字段
         * @param argGood string 同行优秀字段
         */
        function trimShopTrendsData(argData, argMine, argAverage, argGood) {
            if (!Array.isArray(argData)) {
                return;
            }

            return argData.map(function (value, index, array) {
                return {
                    key: getSelectedResult(array.length - index + vm.c.curSelected - 1, vm.c.curSelectedType),
                    mine: DSSX.util.safe(value, argMine, 0),
                    average: DSSX.util.safe(value, argAverage, 0),
                    good: DSSX.util.safe(value, argGood, 0)
                }
            }).sort(function (a, b) {
                return a.key - b.key
            });
        }

        /**
         * @param argValue boolean
         */
        function toggleShowDateWeekSelector(argValue) {
            vm.c.showDateWeekSelector = argValue;
            $timeout(function () {
                argValue && triggerCount === 0 && $('.data-admin-diagnosis-day-week-selector-panel > ul > li.current').trigger('click');
                argValue && triggerCount++;
            });
        }

        /**
         * 周日历变化事件
         * @param weekRange {start,end}
         */
        function weekChange(weekRange) {
            var curTime = new Date(vm.c.curDate.getTime());
            var curDay = '0123456'.charAt(curTime.getDay()); // 获得当前时间为周几
            var dateEnd = curTime - DAY_TIMES_TAMP * (+curDay + 1);
            var selected = (((dateEnd - (new Date(weekRange.end))) / (DAY_TIMES_TAMP * 7))) + 1;

            console.log(selected, weekRange);
            toggleShowDateWeekSelector(false);
            getBusinessData(Math.round(selected), 'week', weekRange.start + '至' + weekRange.end);
        }

        /**
         * @param stats object
         * @param index number
         * @param e event
         */
        function selectDateWeekType(stats, index, e) {
            if (!(index in vm.c.statsMenus)) {
                return;
            }
            vm.c.curStatsIndex = index;

            removeLayDate();
            if (stats.type === 'week') {
                e.stopPropagation();
                return;
            }

            $timeout(function () {
                var selector = '#' + stats.dateId;
                $(selector).val(stats.oldValue);
                laydate.render({
                    elem: selector,
                    theme: 'b',
                    type: stats.type,
                    lang: stats.lang,
                    // value: stats.oldValue,
                    show: true, //直接显示
                    showBottom: false,
                    min: stats.min,
                    max: stats.max,
                    closeStop: '#' + stats.btnId, //这里代表的意思是：点击 test1 所在元素阻止关闭事件冒泡。如果不设定，则无法弹出控件
                    position: 'static',
                    ready: function (value, date) { // 控件打开的时候触发

                    },
                    change: function (value, date, endDate) { // 切换年月的时候触发 要判断是日期选择器还是年月选择器触发 日期 value='2017-08-09' 年月 value='2017-08'

                        if (value.length > 7) {
                            return;
                        }

                        /**
                         * 这里由于点击两边的按钮切换年月时，
                         * 如果时间在合理范围内会直接请求数据，
                         * 然后关闭日历插件，
                         * 所以点击左右两边的按钮时直接return，
                         * 点击具体的年月时请求数据，
                         * 根据判断 上次变化月份 === 点击的月份 上次变化的年份 !== 点击的年份
                         * 来区别是点击具体的年月还是点击两边的按钮来触发的事件
                         */
                        var preLastChange = store.monthPlugin.lastChange;

                        store.monthPlugin.lastChange = {
                            year: date.year,
                            month: date.month
                        };

                        if (preLastChange.month === date.month) {
                            if (preLastChange.year !== date.year) {
                                return;
                            }
                        }

                        var curTime = new Date(value).getTime();
                        if (curTime < validMonthRange.min || curTime > validMonthRange.max) {
                            return;
                        }

                        var selected;
                        switch (value) {
                            case weekRangeAttrs[0]:
                                selected = 3;
                                break;
                            case weekRangeAttrs[1]:
                                selected = 2;
                                break;
                            case weekRangeAttrs[2]:
                                selected = 1;
                                break;
                            default:
                                selected = 1;
                        }

                        console.log(selected);
                        toggleShowDateWeekSelector(false);
                        getBusinessData(selected, 'month', value);
                    },
                    done: function (value, date, endDate) { // 日期选择完毕触发
                        $timeout(function () {
                            var curTime = new Date(vm.c.curDate.getTime());
                            var selectedTime = new Date(value);
                            selectedTime.setHours(0);
                            var selected = Math.floor(((curTime - selectedTime) / DAY_TIMES_TAMP));
                            var type = stats.type === 'date' ? 'day' : 'month';

                            console.log(selected, type);
                            toggleShowDateWeekSelector(false);
                            getBusinessData(selected + 1, type, $filter('date')(selectedTime.getTime(), 'yyyy-MM-dd'));
                        });
                    }
                });
            })
        }

        // 移除laydate
        function removeLayDate() {
            // 如果存在 laydate 则remove
            var laydateEle = $('.laydate-theme-b');
            if (laydateEle.length) {
                for (var i = 0; i < laydateEle.length; i++) {
                    laydateEle[i].remove();
                }
            }
        }

        /**
         * 前后点击
         * @param argNext boolean
         */
        function stepSelect(argNext) {
            getBusinessData(argNext ? vm.c.curSelected - 1 : vm.c.curSelected + 1,
                vm.c.curSelectedType,
                getSelectedResult(argNext ? (vm.c.curSelected - 1) : (vm.c.curSelected + 1), vm.c.curSelectedType));
        }

        /**
         * @param argSelected number
         * @param argType string
         * @returns {string|*}
         */
        function getSelectedResult(argSelected, argType) {
            var res = '',
                date = new Date(vm.c.curDate.getTime());

            switch (argType) {
                case 'day':
                    res = $filter('date')(vm.c.curDate - (argSelected - 1) * DAY_TIMES_TAMP, 'yyyy-MM-dd');
                    break;
                case 'week':
                    var curDay = '0123456'.charAt(date.getDay());
                    var dateEnd = date - DAY_TIMES_TAMP * (+curDay + 1);
                    var dateStart = dateEnd - DAY_TIMES_TAMP * 6;

                    res = $filter('date')(dateStart - (argSelected - 1) * DAY_TIMES_TAMP * 7, 'yyyy-MM-dd') + '至' + $filter('date')(dateEnd - (argSelected - 1) * DAY_TIMES_TAMP * 7, 'yyyy-MM-dd');
                    break;
                case 'month':
                    res = $filter('date')(date.setMonth(date.getMonth() - argSelected), 'yyyy-MM');
                    break;
                default:
                    return '';
            }

            return res;
        }
    }
})();
